import { size, toLower, includes, filter, find, map } from "lodash";

export const ORGANISATION_UNIT_STATUSES = {
  DRAFT: "draft",
  ARCHIVED: "archived"
};

export const getColorByStatus = status => {
  switch (status.toLowerCase()) {
    case ORGANISATION_UNIT_STATUSES.ARCHIVED:
      return "red";
    case ORGANISATION_UNIT_STATUSES.DRAFT:
    default:
      return "gray";
  }
};

export const searchDeep = (searchText, unit) => {
  if (includes(toLower(unit.name), toLower(searchText))) {
    return true;
  }
  unit.organisationUnits = filter(unit.organisationUnits, childUnit =>
    searchDeep(searchText, childUnit)
  );

  return size(unit.organisationUnits);
};

export const filterDeep = (units, searchText) =>
  filter(units, unit => searchDeep(searchText, unit));

export const getOrganisationsAsTreeStructure = units => {
  return nest(units);
};

export const nest = (items, id = null, link = "parentId") =>
  items
    .filter(item => item[link] === id)
    .map(item => ({
      ...item,
      organisationUnits: nest(items, item.id)
    }));

export const getParents = (units, parentId) => {
  const parent = find(units, { id: parentId });
  if (parent) {
    let parents = [parent];
    if (parent.parentId) {
      parents = [...getParents(units, parent.parentId), ...parents];
    }
    return parents;
  }
  return [];
};

export const getUnitsWithParents = items =>
  map(items, item => {
    let parents = [];
    if (item.parentId) {
      parents = getParents(items, item.parentId);
    }
    const subText = size(parents)
      ? map(parents, parent => `${parent.name}`).join(" / ")
      : "Root";
    return { ...item, subText, parents };
  });

export const findDeep = (units, id) => {
  let foundUnit = find(units, { id });
  if (foundUnit) {
    return foundUnit;
  }
  map(units, unit => {
    const deepFoundUnit = findDeep(unit.organisationUnits, id);
    if (deepFoundUnit) {
      foundUnit = deepFoundUnit;
    }
  });
  return foundUnit;
};
